export const TIMEZONE_STORAGE_KEY = 'preferred_timezone';

export const getStoredTimezone = () => {
  if (typeof window === 'undefined') {
    return 'local';
  }

  return window.localStorage.getItem(TIMEZONE_STORAGE_KEY) === 'utc' ? 'utc' : 'local';
};

export const resolveTimezoneMode = (searchParams, persistedTimezone = 'local') => {
  if (searchParams.get('timezone') === 'utc') {
    return 'utc';
  }

  if (searchParams.has('timezone')) {
    return 'local';
  }

  return persistedTimezone;
};